export const OLD_FIREFOX_VERSION = 53;
export const FEATURES_ZOOM_UPPER_THRESHOLD = 14;
export const MARKER_SIZE = 16;

export const MAP_SATELLITE_MIN_ZOOM = 16;
export const MAP_MAX_ZOOM = 18;
export const FIT_FEATURES_MAX_ZOOM = 16;

// Nav
export const TOP_NAV_HEIGHT = 58;

export const NONE_TYPE = 'none';
export const SALE_PRICE_TYPE = 'estimates';
export const RENTAL_PRICE_TYPE = 'rental_price';

// Key for define meilleursagents layers
export const MA_LAYER = 'MA_LAYER';

// Used for Mapbox Layer ids and features type
export const OTHER_PAST_SALE_FEATURE_ID = 'other_past_sale';
export const REALTOR_FEATURE_ID = 'realtor';
export const REFERENCE_FEATURE_ID = 'reference';
export const RELEVANT_PAST_SALE_FEATURE_ID = 'relevant_past_sale';
export const TRANSIT_STATION_FEATURE_ID = 'transit_station';
export const DVF_TRANSACTION_FEATURE_ID = 'transaction_dvf';

export const PARCEL_SELECTED_LAYER_ID = 'parcelle-selected';
export const PLACE_SELECTED_LAYER_ID = 'place-selected';

// Keydown codes
export const ARROW_DOWN_KEYCODE = 40;
export const ARROW_UP_KEYCODE = 38;
export const ENTER_KEYCODE = 13;
export const ENTER_KEY = 'Enter';
export const TAB_KEYCODE = 9;
export const ESC_KEYCODE = 27;

// Typeahead remote call options
export const TYPEAHEAD_DEBOUNCE_MODE = 'debounce';
export const TYPEAHEAD_DEBOUNCE_TIME = 300;

// Geotype label
export const ADDRESS_GEOTYPE_LABEL = 'address';
export const STREET_GEOTYPE_LABEL = 'street';
export const BOROUGH_GEOTYPE_LABEL = 'borough';
export const NEIGHBORHOOD_GEOTYPE_LABEL = 'neighborhood';
export const REGION_GEOTYPE_LABEL = 'region';
export const SUBREGION_GEOTYPE_LABEL = 'subregion';
export const CITY_GEOTYPE_LABEL = 'city';
export const SUBCITY_GEOTYPE_LABEL = 'subcity';
export const ARRMUN_GEOTYPE_LABEL = 'arrmun';

// Color index properties by level
export const MAP_COLOR_PROPS = {
    [SALE_PRICE_TYPE]: {
        country: 'country_sale_color_index',
        region: 'region_sale_color_index',
        subregion: 'subregion_sale_color_index',
        'subregion-price-building': 'subregion_sale_color_index',
        'city-price-iris-geo-no-parcelles': 'city_sale_color_index',
        'city-price-iris-geo-parcelles': 'city_sale_color_index',
        'city-price-city-geo-parcelles': 'city_sale_color_index',
        'city-price-building': 'city_sale_color_index',
        'subregion-geo-city': 'subregion_sale_color_index',
        arrmun: 'city_sale_color_index',
    },
    [RENTAL_PRICE_TYPE]: {
        country: 'country_rental_color_index',
        region: 'region_rental_color_index',
        subregion: 'subregion_rental_color_index',
        city: 'city_rental_color_index',
        'city-rental-blocks': 'city_rental_color_index',
        arrmun: 'city_rental_color_index',
    },
};

export const MAP_MIN_ZOOMS = {
    iris: 15,
};

// Selection properties by level.
// For example if we are at the 'region-idf' level,
// the tile property is 'region_id'
export const SELECTION_PROPS = {
    [SALE_PRICE_TYPE]: {
        country: null,
        region: 'region_id',
        subregion: 'subregion_id',
        'subregion-price-building': 'subregion_id',
        'subregion-geo-city': 'subregion_id',
        'city-price-iris-geo-no-parcelles': 'city_id',
        'city-price-iris-geo-parcelles': 'city_id',
        'city-price-building': 'city_id',
        arrmun: 'arrmun_id',
    },
    [RENTAL_PRICE_TYPE]: {
        country: null,
        region: 'region_id',
        subregion: 'subregion_id',
        city: 'city_id',
        'city-rental-blocks': 'city_id',
    },
};

export const MAP_PALETTES_NONE_ROADMAP = 'rgba(180, 180, 180, 0.4)';
export const MAP_PALETTES_NONE_SATELLITE = 'rgba(180, 180, 180, 0.5)';
export const MAP_PALETTES_OPACITY = '0.6';
export const MAP_SATELLITE_PALETTES_OPACITY = '0.6';
export const MAP_PALETTES = {
    12: [
        `rgba(0,136,85,${MAP_PALETTES_OPACITY})`,
        `rgba(19,190,0,${MAP_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_PALETTES_OPACITY})`,
        `rgba(223,255,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_PALETTES_OPACITY})`,
        `rgba(255,232,47,${MAP_PALETTES_OPACITY})`,
        `rgba(255,213,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_PALETTES_OPACITY})`,
        `rgba(200,0,0,${MAP_PALETTES_OPACITY})`,
    ],
    11: [
        `rgba(0,136,85,${MAP_PALETTES_OPACITY})`,
        `rgba(19,190,0,${MAP_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_PALETTES_OPACITY})`,
        `rgba(223,255,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_PALETTES_OPACITY})`,
        `rgba(255,213,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_PALETTES_OPACITY})`,
        `rgba(200,0,0,${MAP_PALETTES_OPACITY})`,
    ],
    9: [
        `rgba(0,136,85,${MAP_PALETTES_OPACITY})`,
        `rgba(19,190,0,${MAP_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_PALETTES_OPACITY})`,
        `rgba(200,0,0,${MAP_PALETTES_OPACITY})`,
    ],
    7: [
        `rgba(19,190,0,${MAP_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_PALETTES_OPACITY})`,
    ],
    5: [
        `rgba(19,190,0,${MAP_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_PALETTES_OPACITY})`,
    ],
    3: [
        `rgba(174,229,0,${MAP_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_PALETTES_OPACITY})`,
    ],
};

export const MAP_SATELLITE_PALETTES = {
    12: [
        `rgba(0,136,85,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(19,190,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(223,255,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,232,47,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,213,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(200,0,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
    ],
    11: [
        `rgba(0,136,85,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(19,190,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(223,255,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,213,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(200,0,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
    ],
    9: [
        `rgba(0,136,85,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(19,190,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(200,0,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
    ],
    7: [
        `rgba(19,190,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(117,225,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,123,22,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_SATELLITE_PALETTES_OPACITY})`,
    ],
    5: [
        `rgba(19,190,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(174,229,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,10,2,${MAP_SATELLITE_PALETTES_OPACITY})`,
    ],
    3: [
        `rgba(174,229,0,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,248,49,${MAP_SATELLITE_PALETTES_OPACITY})`,
        `rgba(255,165,31,${MAP_SATELLITE_PALETTES_OPACITY})`,
    ],
};

// Max place selectable via typeahead in search bar component
export const SEARCH_FILTERS_MAX_SELETED_PLACES = 10;

/**
 * Maximum past sales fetched.
 * @type {Number}
 */
export const MAX_PAST_SALES_FETCHED = 500;

/**
 * Coordinates of MeilleursAgents at 2 rue des Italiens Paris.
 * @type {Number}
 */
export const MA_COORDINATES = {
    lat: 48.8715543,
    lng: 2.3359278,
};

/**
 * DVF page base path
 * @type {String}
 */
export const DVF_PATH = '/prix-immobilier/dvf';
